import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { createOttoClient, createQueryClient, configFrom } from "@otto/plattform";
import { SessionProvider } from "@otto/plattform";
import { App } from "./App.js";
import "@otto/design/fonts.css";
import "@otto/design/tokens.css";
import "@otto/design/base.css";
import "@otto/design/dashboard.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Element #root fehlt in index.html");

const client = createOttoClient(configFrom(import.meta.env as Record<string, string>));
const queryClient = createQueryClient();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider client={client}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
